import React, {Component, Fragment} from 'react';
import fetch from "fetch-retry";
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import { connect } from "react-redux";
import {number_format} from "../../../utils/formatter";
import autobind from 'autobind-decorator'
import moment from "moment";
import * as InitStatus from "../../../constants/common/InitializationStatus";
import If from "../../common/control/If";
import {addPrefix} from "../../../utils/UriUtil";

@connect(state => ({
  activeDate: state.statistics.activeDate,
  activeDateType: state.statistics.activeDateType,
}), dispatch => ({dispatch}))
class BlogTopEntry extends Component {

  constructor(props) {
    super(props);
    this.maxListCount = 20;
    this.firstListCount = 5;
    this.state = this.getDefaultState()

  }

  // 초기 state
  getDefaultState() {
    return {
      entryData: [],
      activeShowMoreTopEntry: false,
      initialized: InitStatus.INIT_READY,
    };
  }

  // Active date, type을 Watching한다.
  shouldComponentUpdate(nextProps, nextState) {
    if (this.checkIsChangedActiveDateOrType(nextProps)) {
      this.getTopEntry(nextProps)
    }
    return true;
  }

  // 날짜, 타입 변경유부
  @autobind
  checkIsChangedActiveDateOrType(nextProps) {
    const {activeDate, activeDateType} = this.props;
    return activeDate != nextProps.activeDate || activeDateType != nextProps.activeDateType;
  }

  // 인기 게시물 조회
  @autobind
  getTopEntry(nextProps) {
    const {activeDate, activeDateType, dispatch} = nextProps;
    this.setState({initialized: InitStatus.INIT_DOING}, () => {
      fetch(addPrefix(`/manage/statistics/blog/${activeDate}/${activeDateType}/topEntry.json`), {
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        retries: 2,
        retryDelay: 300,
        retryOn: [500],
      })
        .then(jsonResponseHandler(dispatch))
        .then(res => res.json())
        .then(res => {
          const list = res.data.hasOwnProperty('result') ? res.data.result : [];
          this.setState({
            activeShowMoreTopEntry: false,
            entryData: list,
            initialized: InitStatus.INIT_SUCCESS
          });
        })
        .catch(e => {
          console.error(e);
          this.setState({initialized: InitStatus.INIT_FAIL});
          alert('통계 정보를 조회할 수 없습니다. 잠시 후 다시 시도해 주시기 바랍니다.');
        })
    });
  };

  // empty HTML
  renderEmpty() {
    return <div className="wrap_tbl">
      <h4 className="screen_out">인기글</h4>
      <strong className="tit_box">인기글</strong>
      <p className="txt_none">인기 글이 없습니다.</p>
    </div>
  }


  // 날짜 텍스트 치환
  getDateTypeName(dateType) {
    switch (dateType) {
      default :
      case "day" :
        return "일간";
      case "week" :
        return "주간";
      case "month" :
        return "월간";
    }
  }

  // 더보기 노출여부
  @autobind
  changeActiveShowMoreTopEntry() {
    this.setState({activeShowMoreTopEntry: !this.state.activeShowMoreTopEntry})
  }

  // 더보기 버튼
  @autobind
  renderHasMore(length) {
    const {activeShowMoreTopEntry} = this.state;
    return (!activeShowMoreTopEntry && length > this.firstListCount)
      ? <button type="button" className="btn_more" onClick={this.changeActiveShowMoreTopEntry}><span className="ico_blog ico_arr">더보기</span></button>
      : '';
  }

  // 리스트 HTML
  @autobind
  renderListItem(list) {
    const {activeShowMoreTopEntry} = this.state;
    const parsedList = (!activeShowMoreTopEntry && list.length > this.firstListCount)
      ? list.slice(0, this.firstListCount)
      : list;

    return parsedList.map((item, index) => (
      <tr className="row_type1" key={index}>
        <td className="fst">
          <div className="inner_cell"><em>{index + 1}</em></div>
        </td>
        <td>
          <div className="inner_cell">
            <a href={item.permalink} target="_blank" className="link_popular">{item.title}</a>
            <a href={addPrefix(`/manage/statistics/entry/${item.entryId}`)} target="_blank" className="btn_post">통계</a>
          </div>
        </td>
        <td>
          <div className="inner_cell">{number_format(item.count)}</div>
        </td>
        <td className="lst">
          <div className="inner_cell">{moment(item.created).format("YYYY.MM.DD")}</div>
        </td>
      </tr>
    ))
  }

  // 렌더링 로딩
  renderLoading() {
    return <tr className="row_type1 loading">
      <td colSpan="4">
        <div className="inner_cell"><span className="ico_blog ico_loading"></span></div>
      </td>
    </tr>
  }


  render() {
    const {activeDateType} = this.props;
    const {entryData, initialized} = this.state;
    const list = entryData;
    const dateTypeName = this.getDateTypeName(activeDateType);
    const {isDoing, isFail, isEmpty, isSuccess} = InitStatus.init(initialized, entryData);

    return (
      <Fragment>
        <div className="wrap_tbl">
          <h4 className="screen_out">인기글</h4>
          <If condition={isEmpty}>{this.renderEmpty()}</If>
          <If condition={!isEmpty}>
            <table className="tbl_tistory tbl_tistory_type1">
              <caption className="ir_caption">인기 글</caption>
              <colgroup>
                <col style={{width: "34px"}}/>
                <col style={{width: "628px"}}/>
                <col style={{width: "66px"}}/>
                <col style={{width: "116px"}}/>
              </colgroup>
              <thead>
              <tr>
                <th scope="col" colSpan="2" className="fst">
                  <div className="inner_cell">인기글</div>
                </th>
                <th scope="col">
                  <div className="inner_cell">{dateTypeName} 조회수</div>
                </th>
                <th scope="col" className="lst">
                  <div className="inner_cell">작성일</div>
                </th>
              </tr>
              </thead>
              <tbody>
              <If condition={isDoing}>{this.renderLoading()}</If>
              <If condition={!isDoing}>{this.renderListItem(list)}</If>
              </tbody>
            </table>
          </If>
          <If condition={!isDoing}>{this.renderHasMore(list.length)}</If>
        </div>
      </Fragment>
    );
  }
}

export default BlogTopEntry;
